module.exports = __webpack_public_path__ + "img/enter-6a51126.jpg";